import React from 'react';
import _ from 'lodash';
import {State} from 'react-router';
import cn from 'classnames';
import Columns from 'rawr/layout/Columns';
import BoxShadow from 'rawr/style/BoxShadow';
import btn from 'rawr/layout/btn';
import api from 'rawr/api';
import notify from 'rawr/notify';
import AsyncData2 from 'rawr/mixins/AsyncData2';
import InsightLogo from '../../apinsight/style/InsightLogo';
import QBLogo from '../../apinsight/style/QBLogo';
import LoadingSpinner from 'rawr/controls/LoadingSpinner';
import SubjectList from 'rawr/apps/apinsight/controls/SubjectList';

import './Portal.scss';
import {useCapstone} from "../../pl/utils";

export default React.createClass({
	mixins: [State, AsyncData2],
    data: {
        apps: {
            params: () => null,
            promise: () => api('/n/api/apps'),
        },
        subjects: {
            params: () => null,
            promise: () => api('/n/apinsight/api/subjects'),
        }
    },
    componentWillUpdate(props, state={}) {
        const {apps, subjects} = state;

        if (apps === undefined || subjects === undefined) {
            return;
        }

        if (window.current_user.is_student) {
            window.location.href = '/n/student#/';
            return;
        }

        // if user is only in one QB/AP-I course
        // then redirect to that subject with query param
        // so we know where you came from
        if (apps.launchpads.length == 0 && subjects.length == 1) {
            window.location = `/n/apinsight#/${subjects[0].id}?p=1`;
        }
    },
	render() {
        //                          State Guide for PL Courses
        // I'm afraid this makes it look a tad more complicated than it is.
        //  group_active |   course_status    |                State
        // ------------------------------------------------------------------------------------------------------------------
        //     true      |     published      | everyone: see and enter course
        //     true      |      draft         | group: see "Coming Soon!", cannot enter course | staff: see and enter course
        //     false     | draft or published | group: cannot see course                       | staff: see and enter course
        //     either    |     archived       | no one can see or enter course

        const {apps, appsLoading, subjects, subjectsLoading} = this.state;
        const isStaff = window.current_user.is_staff

        // Last case == loading spinner while we redirect.
        if (appsLoading || subjectsLoading || (apps.launchpads.length == 0 && subjects.length == 1)) {
            return <LoadingSpinner />;
        }

        return ( <div className="page_wrapper">
            <span tabIndex={0} className="sr-only">If you are using an assistive technology and encounter any
                issues accessing information on this site, please contact us by filling out the help form.</span>
            {(isStaff || DEBUG) && <button className={cn(btn({color: 'red'}), 'reset-progress-btn')} onClick={function() {
                const resetConfirmation = confirm(`Are you sure you want to reset progress?`); // eslint-disable-line no-alert
                if (resetConfirmation) {
                    api.post(`/n/pl/api/demoreset`).then(function() {
                        localStorage.clear();
                        location.reload();
                    }).catch(notify);
                }
            }}>Reset Progress</button>}

            {DEBUG && <button name='resetAPbraveknight' className={btn({color: 'red'})} onClick={function() {
                api.post(`/n/apinsight/api/reset/APInsightTest`).then(function() {
                    localStorage.clear();
                    location.reload();
                }).catch(notify);
            }}>Reset Test</button>}

            <Columns className="launchpad__columns">
                {apps.launchpads.map((item, index) => {
                    const showableChildren = item.children.filter(c =>
                        c.group_active || (isStaff && c.course_status !== 'archived')
                    );
                    const buttonClasses = cn(btn({size: 'medium', color: 'light_blue'}), 'launch_btn');
                    return (
                        <BoxShadow dist="flush" className="launchpad" key={index}>
                            <div className="launchpad__title">
                                <h1>{item.title}</h1>
                            </div>
                            {showableChildren.map((child, index) => {
                                const {isPrevCapstone, isCurrCapstone, capstoneFlag} = useCapstone(child.id)
                                const draft = isStaff && child.course_status === 'draft';
                                const verb = child.group_active ? 'accessible' : 'visible';
                                if ((capstoneFlag && isPrevCapstone) || (!capstoneFlag && isCurrCapstone)) {
                                    return null
                                }
                                return (
                                    <div className={cn("launchpoint", {draft})} key={index}>
                                        <div className="launchpoint__title">
                                            <h3 className="title__heading">{child.title}</h3>
                                            {draft && <i>Draft - {verb} to staff only</i>}
                                            {child.description ? <p className="title__description">{child.description}</p> : ''}
                                        </div>
                                        <div className="launchpoint__action">
                                            {child.group_active && child.course_status === 'draft' ? (
                                                <button disabled className={btn({size: 'medium'})}>Coming Soon</button>
                                            ) : (
                                                <a href={`/n/pl#/${child.id}`} className={buttonClasses}>Launch</a>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </BoxShadow>
                    );
                })}
                <div className="ap_apps">
                    {apps.insight && (
                        <BoxShadow dist="flush" className="launchpad">
                            <div className="launchpad__title launchpad--has_svg_logo launchpad--has_group_mgmt">
                                <div className="logo_wrap">
                                    <InsightLogo />
                                </div>
                                <a href="/n/groups" className={cn('manage_groups', btn({style: 'minimal'}))}>Manage Groups</a>
                            </div>
                            <SubjectList subjectType="insight"/>
                        </BoxShadow>
                    )}
                    {/* {apps.questionbank && (
                        <BoxShadow dist="flush" className="launchpad">
                            <div className="launchpad__title launchpad--has_svg_logo launchpad--has_group_mgmt">
                                <div className="logo_wrap">
                                    <QBLogo />
                                </div>
                            </div>
                            <SubjectList subjectType="qb"/>
                        </BoxShadow>
                    )} */}
                </div>
            </Columns>
        </div>);
	}
});



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/apps/cbportal/handlers/Portal.jsx
 **/